/**
 * @format
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { setActiveLink } from 'state/slice/sidebar';
import { getMenuSectionsByRole, UserAccessInfo } from '../constants/menuData';
import Menu from '../components/Menu';

/**
 * MenuContainer component
 * Handles Redux state and user role/access for menu configuration
 */
const MenuContainer: React.FC = () => {
  const dispatch = useDispatch();

  // Get menu state from Redux
  const isMenuOpen = useSelector(
    (state: RootState) => (state.sidebar as any).menuCollapse
  );
  const activeLink = useSelector(
    (state: RootState) => (state.sidebar as any).activeLink
  );

  // Get user data from Redux
  const userData = useSelector((state: RootState) => (state.user as any).userData);
  const userRole = userData?.role;
  const userAccess: UserAccessInfo = {
    downlineAccess: userData?.userAccess?.downlineAccess,
    snsAccess: userData?.userAccess?.snsAccess,
  };

  // Get menu sections based on user role and access permissions
  const menuSections = getMenuSectionsByRole(userRole, userAccess);

  const handleNavClick = (linkId: string) => {
    dispatch(setActiveLink(linkId));
  };

  return (
    <Menu
      sections={menuSections}
      isMenuOpen={isMenuOpen}
      activeLink={activeLink}
      onNavClick={handleNavClick}
    />
  );
};

export default MenuContainer;
